import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { AppSettingGetResponse, AppSettingCreateUpdateResponse, AppSettingCreateUpdateRequest } from '@models/app-settings.model';
/**
 * Service for fetching app setting data from the backend API.
 */
@Injectable({
  providedIn: 'root'
})
export class AppSettingService {

  /**
   * Constructs the CustomerService with HttpClient injection.
   * 
   * @param http Angular HttpClient for making HTTP requests
   */
  constructor(private http: HttpClient) { }

  /**
   * Fetches a paginated list of customers from the API.
   * 
   * @returns Observable emitting the API response containing customer profiles
   */
  getAppSetting(): Observable<AppSettingGetResponse> {
    const token: string | null = localStorage.getItem('token');
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ` ${token}`  // if needed
    });
    const fetchApi: string = `${environment.api_url}/app-settings`;
    return this.http.get<AppSettingGetResponse>(fetchApi, { headers });
  }

  /**
   * Fetches a paginated list of customers from the API.
   * 
   * @param app_setting_create_update app setting create or update base on input data  
   * @returns Observable emitting the API response containing customer profiles
   */
  orderCreate(app_setting_create_update: AppSettingCreateUpdateRequest): Observable<AppSettingCreateUpdateResponse> {

    const token: string | null = localStorage.getItem('token');
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ` ${token}`  // if needed
    });

    const fetchApi: string = `${environment.api_url}/app-settings/create-or-update`;
    return this.http.post<AppSettingCreateUpdateResponse>(fetchApi, app_setting_create_update, { headers });

  }

}